import { useState } from "react";
import useFetchBlob from '@/hooks/useFetchBlob';
import {
  Box,
  Backdrop,
  CircularProgress,
  Alert
} from "@mui/material";
import {
  PhotoCamera as PhotoCameraIcon
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import ActionButton from "./ActionButton";
// TODO Выяснить почему алерт использовался от другого компонента - setCheckError, setCheckErrorMessage

const ActionButtonTakePhoto = ({ 
  channelId,
}) => {
  const { t } = useTranslation();
  const [backdrop, setBackdrop] = useState(false);
  const { 
    isLoading: isFetching,
    objectUrl,
    error,
  } = useFetchBlob(
    channelId ? `api/v2/current_picture/${channelId}` : '',
    { skip: !channelId || !backdrop }
  );

  const onBackdropClick = () => {
    setBackdrop(false)
  }

  if (!channelId) return null;

  return (
    <>
      <ActionButton
        color="warning"
        startIcon={<PhotoCameraIcon />}
        onClick={() => setBackdrop(true)}
        >
          {t('make_photo')}
      </ActionButton>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdrop || isFetching}
        onClick={onBackdropClick}
      >
        {isFetching && <CircularProgress color="inherit" />}
        {!isFetching && objectUrl && backdrop && (
          <Box component="img" src={ objectUrl } sx={{ maxWidth: '550px' }} />
        )}
        {
          !isFetching && error && (
            <Alert severity="error">{
              t('error_occurred') 
              + ': ' 
              + (error?.data?.message || error?.error || error?.message || '') 
              }
            </Alert>
          )
        }
      </Backdrop>
    </>
  )
}

export default ActionButtonTakePhoto;
